import { ComboBoxModel } from "@genexus/chameleon-controls-library";
import { ObjectType } from "../../../../components";

export const mapObjectTypeToComboBoxItemModel = (
  objectTypeModel: ObjectType[]
): ComboBoxModel =>
  objectTypeModel.map(objectType => ({
    value: objectType.id,
    caption: objectType.name,
    startImgSrc: objectType.icon
  }));
